const StatementSection = () => {
  return (
    <section className="statement" id="statement">
      <div className="wrap statement-grid reveal">
        <div className="statement-left">
          <div className="kicker">01 — Point of view</div>
          <div className="statement-meta">
            <span>Est. Studio</span>
            <span>—</span>
            <span>Toronto</span>
          </div>
        </div>
        <div className="statement-right">
          <h2>
            Quiet luxury.
            <br />
            <span className="accent">Sculptural form.</span>
            <br />
            Enduring place.
          </h2>
          <p>
            We pursue simplicity not as an aesthetic, but as a discipline — allowing light, materiality, scale, and detail to speak with clarity.
          </p>
        </div>
      </div>
    </section>
  );
};

export default StatementSection;
